// src/components/course/ProgressItem.jsx
import React from 'react';
import { AiOutlineRobot } from 'react-icons/ai';
import { FiCheckCircle, FiPlay, FiFileText } from 'react-icons/fi';
import { MdOutlineQuiz } from 'react-icons/md';

const ProgressItem = ({
  title,
  progress,
  isAIEnabled,
  isActive,
  onClick,
  isLocked,
  type,
  isCollapsed,
  order
}) => {
  const isDone = progress === 100;
  const isQuiz = type === 'quiz' || type === 'review_quiz';

  if (isCollapsed) {
    return (
      <div
        onClick={() => !isLocked && onClick(order + 1)}
        className={`
          mx-2 my-1 flex flex-col items-center justify-center py-3 rounded-xl cursor-pointer transition-all duration-150
          ${isActive ? 'bg-blue-50 ring-2 ring-blue-200' : 'hover:bg-slate-50'}
          ${isLocked ? 'opacity-40 cursor-not-allowed' : ''}
        `}
      >
        <div className={`w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-bold
          ${isDone ? 'bg-emerald-100 text-emerald-600' : isActive ? 'bg-blue-100 text-blue-600' : 'bg-slate-100 text-slate-500'}`}>
          {isDone ? <FiCheckCircle size={14} /> : order + 1}
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={() => !isLocked && onClick(order + 1)}
      className={`
        group mx-3 my-1 rounded-xl cursor-pointer transition-all duration-150
        ${isActive
          ? 'bg-blue-50 ring-2 ring-blue-200 shadow-sm'
          : 'hover:bg-slate-50 ring-1 ring-transparent hover:ring-slate-200'}
        ${isLocked ? 'opacity-40 cursor-not-allowed' : ''}
      `}
    >
      <div className="flex items-center gap-3 px-3 py-3.5">
        {/* Number / status badge */}
        <div className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-bold transition-colors
          ${isDone
            ? 'bg-emerald-100 text-emerald-600'
            : isActive
              ? 'bg-blue-500 text-white shadow-sm shadow-blue-200'
              : 'bg-slate-100 text-slate-400 group-hover:bg-slate-200'}`}>
          {isDone ? <FiCheckCircle size={13} /> : isActive ? <FiPlay size={10} className="ml-0.5" /> : order + 1}
        </div>

        {/* Title */}
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-semibold leading-snug line-clamp-2 transition-colors
            ${isActive ? 'text-blue-700' : isDone ? 'text-slate-500' : 'text-slate-700 group-hover:text-slate-900'}`}>
            {title}
          </p>
          <div className="flex items-center gap-1.5 mt-1">
            {isQuiz
              ? <MdOutlineQuiz size={13} className={isActive ? 'text-blue-400' : 'text-amber-400'} />
              : <FiFileText size={12} className={isActive ? 'text-blue-400' : 'text-slate-300'} />}
            <span className={`text-xs font-medium ${isActive ? 'text-blue-400' : 'text-slate-400'}`}>
              {isQuiz ? 'Quiz' : 'Lesson'}
            </span>
            {isAIEnabled && (
              <span className="flex items-center gap-0.5 ml-0.5 bg-violet-50 text-violet-500 border border-violet-100 text-[10px] font-semibold px-1.5 py-0.5 rounded-full">
                <AiOutlineRobot size={10} /> AI
              </span>
            )}
          </div>
        </div>

        {/* Done check on right */}
        {isDone && !isActive && (
          <FiCheckCircle size={13} className="shrink-0 text-emerald-400" />
        )}
      </div>

      {/* Active indicator bar */}
      {isActive && (
        <div className="mx-3 mb-2.5 h-1 rounded-full bg-blue-100 overflow-hidden">
          <div className="h-full bg-blue-400 rounded-full w-1/3 animate-pulse" />
        </div>
      )}
    </div>
  );
};

export default ProgressItem;
